"use strict";

import Css from './css';
import Easing from './easing';
import Animate from './animate';

const requestAnimFrame = Animate.requestAnimFrame;

export default {
    easeInStyleProperty: function (el, styleProp, initialValue, finalValue, duration, easing, callback){
        var s = el.style,
            initialTime = Date.now(),
            startingValue = parseFloat(initialValue),
            change = parseFloat(finalValue) - startingValue,
            duration = (typeof(duration) === 'undefined') ? 300 : duration,
            stylePropPostFixMeasurement = styleProp == 'opacity' ? '' : 'px',
            easing = easing || 'none';

        s[styleProp] = startingValue + stylePropPostFixMeasurement;

        if(styleProp == 'height' || styleProp == 'width')
            s.overflow='hidden';

        var easeTheStyle = function() {
            var currentTime = Date.now() - initialTime;
            s[styleProp] = Easing[easing](currentTime, startingValue, change, duration) + stylePropPostFixMeasurement;
            if (currentTime <= duration) {
                requestAnimFrame(easeTheStyle);
            } else {
                complete();
                callback(s);
            }
        };
        var complete = function(){
            s[styleProp] = finalValue + stylePropPostFixMeasurement;
            s.height = '';
            s.overflow = '';
         };
        easeTheStyle();
    }
    /*fadeOut: function(el, duration) {
        var s = el.style,
            step = 20/(duration || 300);
        s.opacity = s.opacity || 1;
        (function fade() {
            (s.opacity -= step) < 0 ? s.display = "none" : requestAnimFrame(fade);
        })();
    },
    fadeIn: function (el, duration, display) {
        var s = el.style,
            step = 20/(duration || 300);
        s.opacity = s.opacity || 0;
        s.display = display || "block";
        (function fade() {
            (s.opacity = parseFloat(s.opacity)+step) > 1 ? s.opacity = 1 : requestAnimFrame(fade);
         })();
    },
    slideDown: function (el, duration){
        var s = el.style,
            destinationHeight = parseFloat(Css.getStyle(el,'height')),
            step = 20/(duration || 300)*1000,
            floatHeight = parseFloat(s.height || 0);
        s.height= floatHeight+'px';
        s.overflow='hidden';
        var slide = function() {
            floatHeight += step;
            s.height = floatHeight+'px';
            floatHeight > destinationHeight ? complete() : requestAnimFrame(slide);
        };
        var complete = function(){
            s.height = '';
            s.overflow = '';
        };
        slide();
    },
    slideDownEasing: function (el, duration){
        var s = el.style,
            currentTime = 0,
            destinationHeight = parseFloat(Css.getStyle(el,'height')),
            start = parseFloat(s.height || 0),
            change = destinationHeight - start,
            increment = 20,
            duration = (typeof(duration) === 'undefined') ? 300 : duration;

        s.height= start+'px';
        s.overflow='hidden';
        var slide = function() {
            currentTime += increment;
            s.height = Easing.easeInOutQuad(currentTime, start, change, duration) + 'px';
            if (currentTime < duration) {
                requestAnimFrame(slide);
            } else {
                complete();
            }
        };
        var complete = function(){
            s.height = '';
            s.overflow = '';
        };
        slide();
    },
    slideUp: function (el, duration, callback){
        var s = el.style,
            destinationHeight = 0,
            floatHeight = 0,
            step = 20/(duration || 300)*1000,
            floatHeight = parseFloat(Css.getStyle(el,'height'));
        s.height= floatHeight+'px';
        s.overflow='hidden';
        var slide = function() {
            floatHeight -= step;
            s.height = floatHeight+'px';
            floatHeight <= destinationHeight ? callback() : requestAnimFrame(slide);
        };
        slide();
    },
    slideUpEasing: function (el, duration, callback){
        var s = el.style,
            currentTime = 0,
            destinationHeight = 0,
            start = parseFloat(Css.getStyle(el,'height')),
            change = destinationHeight - start,
            increment = 20,
            duration = (typeof(duration) === 'undefined') ? 300 : duration;

        s.height= start+'px';
        s.overflow='hidden';
        var slide = function() {
            currentTime += increment;
            //t: current time, b: beginning value, c: change In value, d: duration
            s.height = Easing.easeInOutQuad(currentTime, start, change, duration) + 'px';
            if (currentTime < duration) {
                requestAnimFrame(slide);
            } else {
                complete();
                callback();
            }
        };
        var complete = function(){
            s.height = '';
            s.overflow = '';
        };
        slide();
    },*/
};
